import { GESTION_DOCUMENTAL_ITEMS } from "./gestionDocumentalCatalog";

/** Documentos de supervisión ya cubiertos por gestión documental — no se piden de nuevo. */
export const REVISION_DOCS_CUBIERTOS_POR_GESTION = new Set([
  "revision_doc_carta_remisoria",
  "revision_doc_autorizacion_ley_1581",
  "revision_doc_cedula_propietario",
  "revision_doc_cedula_matricula_disenador",
  "revision_doc_carta_autorizacion_tramites",
  "revision_doc_rut",
  "revision_doc_certificado_libertad",
  "revision_doc_camara_comercio",
  "revision_doc_licencias_construccion",
  "revision_doc_autodeclaracion_retie",
  "revision_doc_presupuesto",
  "revision_doc_planos",
]);

export type ExpedienteDocRef = { tipo: string; label: string };

export type ExpedienteSeccion = {
  id: string;
  titulo: string;
  documentos: ExpedienteDocRef[];
  /** Si true, los tipos RETIE se toman del workflow (tipos_requeridos). */
  retieDinamico?: boolean;
};

const DOCS_SOLICITUD: ExpedienteDocRef[] = [
  { tipo: "solicitud_documento_identidad", label: "Documento de identidad del solicitante" },
  { tipo: "solicitud_acreditacion_uso_especial", label: "Documento que acredita uso especial" },
  { tipo: "solicitud_formato_creg_e1", label: "Formato solicitud servicio público CREG E1" },
  { tipo: "factibilidad_oficio_factibilidad", label: "Oficio de factibilidad" },
  { tipo: "factibilidad_soportes_adicionales", label: "Soportes adicionales factibilidad" },
];

const DOCS_DISENO: ExpedienteDocRef[] = [
  { tipo: "factibilidad_plano_diseno", label: "Plano de diseño (AutoCAD)" },
  { tipo: "factibilidad_presupuesto_diseno", label: "Presupuesto de diseño" },
];

const DOCS_LIQUIDACION: ExpedienteDocRef[] = [
  { tipo: "factibilidad_liquidacion_diseno", label: "Liquidación de diseño" },
];

const DOCS_SUPERVISION_UNICOS: ExpedienteDocRef[] = [
  { tipo: "revision_doc_memorias_calculo", label: "Memorias de cálculo" },
  { tipo: "revision_doc_comprobante_pago_diseno", label: "Comprobante de pago diseño" },
  { tipo: "revision_doc_acta_levantada_terreno", label: "Acta levantada en terreno (opcional)" },
  { tipo: "revision_doc_solicitud_grandes_clientes", label: "Solicitud de grandes clientes" },
  { tipo: "revision_doc_declaracion_cumplimiento_deudas", label: "Declaración de cumplimiento de deudas" },
  { tipo: "revision_doc_validacion_provisional", label: "Documento de validación provisional" },
];

const DOCS_EJECUCION: ExpedienteDocRef[] = [
  { tipo: "ejecucion_doc_carta_cambio_constructor", label: "Carta autorización cambio de constructor (si aplica)" },
  { tipo: "ejecucion_doc_matricula_constructor", label: "Matrícula profesional del constructor" },
  { tipo: "ejecucion_doc_habeas_data_constructor", label: "Formato habeas data del constructor" },
  { tipo: "ejecucion_doc_solicitud_supervisor_obra", label: "Solicitud de supervisor de obra" },
  { tipo: "ejecucion_doc_informe_primera_visita", label: "Informe de primera visita firmado" },
  { tipo: "ejecucion_doc_factura_liquidacion", label: "Factura de liquidación de trabajos" },
  { tipo: "ejecucion_doc_soporte_pago", label: "Soporte de pago de factura" },
  { tipo: "ejecucion_doc_acta_visita", label: "Acta de visita de avance de obra" },
  {
    tipo: "ejecucion_doc_documentacion_transformador",
    label: "Documentación de transformador (factura, protocolos, garantías)",
  },
  { tipo: "ejecucion_doc_registro_fotografico", label: "Registro fotográfico nodo/transformador" },
  { tipo: "ejecucion_doc_orden_movilizacion", label: "Orden de movilización aprobada" },
];

export const EXPEDIENTE_SECCIONES: ExpedienteSeccion[] = [
  {
    id: "solicitud",
    titulo: "Solicitud del servicio",
    documentos: DOCS_SOLICITUD,
  },
  {
    id: "gestion_documental",
    titulo: "Gestión documental (conexiones complejas)",
    documentos: GESTION_DOCUMENTAL_ITEMS.map((i) => ({ tipo: i.tipo, label: i.label })),
  },
  {
    id: "diseno",
    titulo: "Diseño",
    documentos: DOCS_DISENO,
  },
  {
    id: "liquidacion",
    titulo: "Liquidación",
    documentos: DOCS_LIQUIDACION,
  },
  {
    id: "supervision",
    titulo: "Supervisión y aprobación",
    documentos: DOCS_SUPERVISION_UNICOS,
  },
  {
    id: "retie",
    titulo: "Equipos RETIE",
    documentos: [],
    retieDinamico: true,
  },
  {
    id: "ejecucion",
    titulo: "Ejecución de obras",
    documentos: DOCS_EJECUCION,
  },
];

const ETIQUETAS_RETIE: Record<string, string> = {
  transformador: "Transformador",
  medidor: "Medidor",
  tc: "TC (transformador de corriente)",
  tp: "TP (transformador de potencial)",
};

export function etiquetaRetieTipo(tipo: string): string {
  const m = String(tipo).match(/^retie_(transformador|medidor|tc|tp)_(\d+)$/i);
  if (!m) return tipo.replace(/_/g, " ");
  return `${ETIQUETAS_RETIE[m[1].toLowerCase()] || m[1]} #${m[2]}`;
}

export function etiquetaDocumentoExpediente(tipo: string): string {
  for (const sec of EXPEDIENTE_SECCIONES) {
    const found = sec.documentos.find((d) => d.tipo === tipo);
    if (found) return found.label;
  }
  if (/^retie_/.test(tipo)) return etiquetaRetieTipo(tipo);
  return tipo.replace(/_/g, " ");
}
